"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUserApiClient = createUserApiClient;
const infra_1 = require("../infra");
const axios_client_1 = require("@invivodf/axios-client");
const index_const_1 = require("../index.const");
function createUserApiClient(apiHost, options) {
    const logger = options.logger ?? index_const_1.NOOP_LOGGER;
    const client = (0, axios_client_1.createAxiosClient)(apiHost, options);
    async function sendInvite(params) {
        try {
            await client.post('/v1/invite', params.request);
        }
        catch (err) {
            logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    async function registerUser(params) {
        try {
            const response = await client.post('/v2/users', params.newUser);
            const location = response.headers?.location || '';
            const matches = location.match(/\/v2\/users\/([0-9]*)/) || [];
            if (matches.length > 0) {
                const userId = matches[1];
                return userId && +userId || undefined;
            }
            return undefined;
        }
        catch (err) {
            logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    async function fetchUsersByPartnerIdAndMembershipNumber(partnerId, membershipNumber, onlyConfirmedProfiles = true) {
        try {
            const params = { all_profiles: !onlyConfirmedProfiles };
            const response = await client.get(`/v1/partners/${partnerId}/memberships/${membershipNumber}/users`, { params });
            return response.data;
        }
        catch (err) {
            logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    async function createUser(email, hasAcceptedFarmerCgu) {
        try {
            const response = await client.post('/v1/users', {
                email,
                has_accepted_farmer_cgu: hasAcceptedFarmerCgu
            });
            return response.data;
        }
        catch (err) {
            logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    async function createConfirmedProfile(userId, membershipNumber, partnerId) {
        try {
            const response = await client.post('/v1/confirmed-profiles', {
                user_id: userId,
                membership_number: membershipNumber,
                partner_id: partnerId
            });
            return response.data;
        }
        catch (err) {
            logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    async function setCurrentCustomer(request) {
        try {
            await client.post('/v1/users/me/currentCustomer', request);
            return;
        }
        catch (err) {
            logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    async function checkUserPermissions(userId, permissions) {
        try {
            const params = { permissions: permissions.join(',') };
            const response = await client.get(`/v1/users/${userId}/permissions/check`, { params });
            return response.data;
        }
        catch (err) {
            logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    return {
        sendInvite,
        registerUser,
        fetchUsersByPartnerIdAndMembershipNumber,
        createUser,
        createConfirmedProfile,
        setCurrentCustomer,
        checkUserPermissions
    };
}
//# sourceMappingURL=data:application/json;base64,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